import { ApiClient } from '../../ApiClient';
class FavoritesApiClient {
    constructor() {
        this.apiClient = new ApiClient('/api/favorites');
    }
    async add(sku) {
        await this.apiClient.post('/add', { sku });
    }
    async remove(sku) {
        await this.apiClient.post('/remove', { sku });
    }
}
const favoritesApiClient = new FavoritesApiClient();
export default favoritesApiClient;
